import { render } from "./DeployInstanceBackupSelection.vue?vue&type=template&id=5f6ca734"
import script from "./DeployInstanceBackupSelection.vue?vue&type=script&lang=js"
export * from "./DeployInstanceBackupSelection.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/tmp.J0U5ZeTglF/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__